import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Homepage from "@/pages/Homepage";
import MarketingStrategy from "@/pages/MarketingStrategy";
import Straly from "@/pages/Straly";
import Saivor from "@/pages/Saivor";
import Properly from "@/pages/Properly";
import TuneUpBook from "@/pages/TuneUpBook";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Disclaimer from "@/pages/Disclaimer";
import ReturnPolicy from "@/pages/ReturnPolicy";
import TermsConditions from "@/pages/TermsConditions";
import DeleteAccount from "@/pages/DeleteAccount";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/marketing-strategy" element={<MarketingStrategy />} />
          <Route path="/straly" element={<Straly />} />
          <Route path="/saivor" element={<Saivor />} />
          <Route path="/properly" element={<Properly />} />
          <Route path="/tune-up-book" element={<TuneUpBook />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/delete" element={<Navigate to="/delete-account/" replace />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
